"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.filterTranslationKeyMap = exports.FilterButton = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _contexts = require("../../../contexts");
var _hooks = require("../../../hooks");
var _models = require("../../../models");
var _jsxRuntime = require("react/jsx-runtime");
const FilterButtonInner = (0, _mui.styled)(_components.Button, {
    shouldForwardProp: (props)=>props !== 'isCurrent'
})((param)=>{
    let { isCurrent } = param;
    return {
        textDecoration: isCurrent ? 'underline' : 'none'
    };
});
const filterTranslationKeyMap = exports.filterTranslationKeyMap = {
    [_models.GodModeRowFiltering.all]: _models.TranslationKey.filterAllXValue,
    [_models.GodModeRowFiltering.qualified]: _models.TranslationKey.filterQualifiedXValue,
    [_models.GodModeRowFiltering.used]: _models.TranslationKey.filterUsedXValue,
    [_models.GodModeRowFiltering.error]: _models.TranslationKey.filterErrorsXValue
};
const FilterButton = (param)=>{
    let { filter, dataTestID } = param;
    const { formatMessage } = (0, _hooks.useTranslations)();
    const { filterCounts, setFilter, filter: currentFilter } = (0, _contexts.useCheckoutGodMode)();
    const onFilterClick = (0, _react.useCallback)(()=>setFilter(filter), [
        setFilter,
        filter
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(FilterButtonInner, {
        "data-testid": dataTestID,
        isCurrent: filter === currentFilter,
        size: "small",
        onClick: onFilterClick,
        children: formatMessage(filterTranslationKeyMap[filter], {
            value: filterCounts[filter]
        })
    });
};
exports.FilterButton = FilterButton;
